import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import * as STATIC from '../config/static';
const stylesBt = theme => ({
    button: {
        margin: theme.spacing.unit,
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
});
let tick;
class CountDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      second:props.second?props.second:0,

      isEnd:false,
percent:0
    }
    //console.log(props);

  }
  componentDidMount(){
      this.startShowing();
  }
  startShowing(){
    if(this.state.second>0&&!this.state.isEnd)
    {
      let _this=this;

      //console.log(interval);
       tick = setInterval(function(){
  // do your thing
  let second = _this.state.second;
    if(second>0)
    {
      second--;
    }
    if(_this.props.onUpdateRemain)
    {
      _this.props.onUpdateRemain(second);
    }
        if(second==0)
        {
        clearInterval(tick);
        _this.props.isEnd();
        _this.setState({isEnd:true});
      }
      else {
        _this.setState({second});
      }



    },1000);
  }
  }
  componentWillUnmount(){
    if(tick)
    clearInterval(tick);
  }
  // componentWillReceiveProps(props)
  // {
  //   if(props.second>0&&this.state.isEnd)
  //   {
  //     this.setState({showing:true,isEnd:false,index:0,numbers:props.numbers,second:props.second},()=>this.startShowing());
  //   }
  // }

  getPercent(){
    let rel = '';
    let {second,isEnd} = this.state;

    if(isEnd)
    rel = '0';
    else {
      rel = second;
    }


    rel = ((this.props.second-parseInt(rel))/this.props.second)*100;
    //console.log(rel);
    return rel;
  }

    render() {
        const { classes, width,size } = this.props;
        let {second,isEnd} = this.state;
        let DWIDTH = 1024;
        let bsRate = 615/2048;
        let bbsRate = 27/2048;
        let bRate = 615 / 47;
        let bbRate = 27/43;
        let bWidth = width*bsRate;
        let bHeight = bWidth/bRate;
        let bbWidth = width*bbsRate;
        let bbHeight = bbWidth/bbRate;
        let percent = this.getPercent();

        //console.log(mLeft)
        return (
          <div style={{position: 'relative'}}>
          <img src='assets/comp/bar.png'  style ={{width:bWidth,height:bHeight}}/>
          <div style={{position: 'absolute',width:bWidth-STATIC.calSize(20,DWIDTH, width),top:STATIC.calSize(9, DWIDTH, width),left:STATIC.calSize(10,DWIDTH, width)}}>
            <div style={{  backgroundColor: 'red', height: STATIC.calSize(6, DWIDTH, width), width:percent+'%' }} />
          </div>

          <div style={{position:'absolute',bottom:STATIC.calSize(0, DWIDTH, width),width:bWidth-STATIC.calSize(20,DWIDTH, width),left:STATIC.calSize(10,DWIDTH, width)}}><img src='assets/comp/bar-button.png'  style ={{width:bbWidth,height:bHeight,marginLeft:percent+'%'}}/>
          </div>
        </div>
        );
    }
}

CountDown.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(stylesBt)(CountDown);
